import {
  createBrowserRouter,
  createRoutesFromChildren,
  matchRoutes,
  useLocation,
  useNavigationType,
} from "react-router-dom";
import * as Sentry from "@sentry/react";
import {
  buildNumber,
  currentEnv,
  googleGAKey,
  isDevelopment,
  sentryDSN,
} from "./environment";
import ReactGA from "react-ga4";
import { useEffect } from "react";
import axios from "axios";

export const analyticsSetup = () => {
  if (isDevelopment) return;

  ReactGA.initialize(googleGAKey, {
    gaOptions: {
      allowLinker: true,
      cookieDomain: "auto",
    },
  });
  // ReactGA.ga("require", "linker");
  // ReactGA.ga("linker:autoLink", ["storeify.com", "storeify.ca"]);

  Sentry.init({
    dsn: sentryDSN,
    release: buildNumber.toString(),
    environment: currentEnv,
    replaysSessionSampleRate: 0.1,
    replaysOnErrorSampleRate: 1.0,
    tracesSampleRate: 1.0,
    enableLogs: true,
    integrations: [
      Sentry.replayIntegration(),
      Sentry.reactRouterV6BrowserTracingIntegration({
        useEffect,
        useLocation,
        useNavigationType,
        createRoutesFromChildren,
        matchRoutes,
      }),
    ],
    beforeSend: (event, hint) => {
      // we can filter sentry events here
      const error = hint.originalException;

      // if it's an AxiosError with a 401 status, ignore it
      if (axios.isAxiosError(error) && error?.response?.status === 401) {
        return null; // this tells Sentry to drop the event
      }

      return event;
    },
  });
};

export const getCreateRouterWithSentry = () => {
  // In Sentry v10, routing is handled by reactRouterV6BrowserTracingIntegration
  // No need to wrap createBrowserRouter separately
  return createBrowserRouter;
};

export const getGclid = (): string | null => {
  // First try to get from URL
  const urlParams = new URLSearchParams(window.location.search);
  const gclidFromUrl = urlParams.get("gclid");

  if (gclidFromUrl) {
    return gclidFromUrl;
  }

  // Then try to get from cookie (if GTM Conversion Linker is enabled)
  const cookies = document.cookie.split(";");

  for (let cookie of cookies) {
    const [name, value] = cookie.trim().split("=");

    if (name === "gclid") {
      return value;
    }
  }

  return null;
};
